import scroll from 'core/scroll';
import { bindEmitterMethod } from 'helpers/bind';
import mqStore from 'store/mqStore';
import InternalPage from './InternalPage';
export default class CheckoutPage extends InternalPage {
    isCheckoutInternalPage = true;
    constructor(el, options) {
        super(el, options);
        el.classList.add('checkout-page');
    }
    pageName() {
        return 'CheckoutPage';
    }
    initialized() {
        super.initialized();
    }
    bindEvents(add) {
        super.bindEvents(add);
        const emitterMethod = bindEmitterMethod(add);
        this[emitterMethod]('show:complete', this.onShowComplete);
    }
    show(previousPage) {
        if (mqStore.tabletPortrait.get())
            scroll.scrollTo(0, { duration: 0 });
        if (!previousPage) {
            this.el.style.opacity = '1';
            this.showChildren();
            return Promise.resolve();
        }
        else {
            return super.show(previousPage);
        }
    }
    onShowComplete = async () => {
        let delay = 0;
        if (mqStore.tabletPortrait.get())
            delay = 300;
        setTimeout(() => {
            const bbox = this.el.getBoundingClientRect();
            const scrollable = (bbox.height + (bbox.top + window.scrollY)) > window.innerHeight;
            if (scrollable) {
                const target = this.el.querySelector('[data-step-name');
                target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            else {
                scroll.scrollTo(0);
            }
        }, delay);
    };
    async hide(nextPage) {
        await super.hide();
        if (this.pageName().includes('Checkout'))
            // scroll.scrollTo(0)
            return Promise.resolve();
    }
}
